import './ForgotPassword.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'rsuite';

import ForgotPasswordForm from '@/common/components/organisms/ForgotPasswordForm/ForgotPasswordForm';

import {
  ForgotPasswordDefaultProps,
  ForgotPasswordPropTypes,
} from './ForgotPassword.proptypes';

const ForgotPassword = ({ closeModal, isOpen }) => {
  const { t } = useTranslation();

  return (
    <Modal
      className="modal-forgot-password"
      data-qa-id="modal-forgot-password"
      onClose={closeModal}
      open={isOpen}
    >
      <Modal.Header />
      <Modal.Body>
        <h1 className="rs-modal-title">
          {t('ebat:entities:common.modal.forgot_password.title')}
        </h1>
        <p className="description">
          {t('ebat:entities:common.modal.forgot_password.description')}
        </p>
        <ForgotPasswordForm onSuccess={closeModal} />
      </Modal.Body>
    </Modal>
  );
};

ForgotPassword.defaultProps = {
  ...ForgotPasswordDefaultProps,
};

ForgotPassword.propTypes = {
  ...ForgotPasswordPropTypes,
};

export default ForgotPassword;
